import React, { useState, useEffect } from "react";
import "./index.css";
import "../../Styles/GlobalStyles/GlobalStyles.css";

import logo from "../../Assets/Logo/logo.png";
import { ThemeProvider } from "@mui/material/styles";
import ChangePasswordForm from "../../Components/ChangePassword/ChangePasswordForm";
import { muiCustomTheme } from "../../Styles/GlobalStyles/MuiCustomTheme";
// import ImageSlider from "../../Components/ChangePassword/ImageSlider/ImageSlider";
import Preloader from "../../Components/Preloader/Preloader";

const ChangePassword = () => {
  let allImages = document.querySelectorAll("img");
  allImages.forEach((value) => {
    value.oncontextmenu = (e) => {
      e.preventDefault();
    };
  });

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 2000);
  }, []);

  return (
    <>
      {loading === true ? (
        <Preloader />
      ) : (
        <ThemeProvider theme={muiCustomTheme}>
          <div className="login-page">
            {/* <ImageSlider /> */}

            <div className="login-form-container">
              <div className="logo-div">
                <img src={logo} alt="" />
              </div>
              <div className="change-password-header-text">
                <h1>Change Password</h1>
                <small style={{width: ""}}>As a first time user, please change the password to your account</small>
              </div>
              <ChangePasswordForm />
            </div>
          </div>
        </ThemeProvider>
      )}
    </>
  );
};

export default ChangePassword;
